import React, { useState } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components

import PackageOption from '../PackageOption';
import { PackagePopup } from '../PackagePopup';

import dataIcon from './icons/data.svg';
import smsIcon from './icons/sms.svg';
import voiceIcon from './icons/voice.svg';

import { roamingParamShape, accumulatorShape, packageInfoShape } from '../../../propTypes';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const ICONS_CONFIG = {
  data: dataIcon,
  sms: smsIcon,
  voice: voiceIcon,
};

const PackageList = ({
  params,
  isOffer,
  accumulator,
  packageInfo,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentOperationType, setCurrentOperationType] = useState(null);

  const currentPackage = packageInfo?.find((item) => item.operationType === currentOperationType);

  const handleClick = (type) => {
    setIsOpen(true);
    setCurrentOperationType(type);
  };

  const handleClose = () => {
    setIsOpen(false);
    setCurrentOperationType(null);
  };

  return (
    <div className={cx('tabs')}>
      {params.map((param) => {
        const onClick = param.isPackage ? handleClick : null;

        return (
          <PackageOption
            key={param.operationType}
            operationType={param.operationType}
            value={param.value}
            title={param.title}
            description={param.description}
            onClick={onClick}
            icon={ICONS_CONFIG[param.operationType]}
            accumulatorData={accumulator}
            isOffer={isOffer}
          />
        );
      })}
      <PackagePopup
        isOpen={isOpen}
        param={currentPackage}
        onClose={handleClose}
      />
    </div>
  );
};

PackageList.propTypes = {
  isOffer: PropTypes.bool,
  params: PropTypes.arrayOf(roamingParamShape),
  accumulator: PropTypes.arrayOf(accumulatorShape),
  packageInfo: PropTypes.arrayOf(packageInfoShape),
};

export { PackageList };
